import * as types from './actionTypes';
import axios from 'axios';
import { getHeader, getToken } from '../helper';

function getCompaniesReceive(data) {
    return {
        type: types.LOAD_COMPANIES_SUCCESS,
        payload: data
    }
}

function getCompaniesRequest() {
    return {
        type: types.LOAD_COMPANIES_REQUEST
    }
}

function getCompaniesError(messages) {
    return {
        type: types.LOAD_COMPANIES_FAILURE,
        payload: messages
    }
}

export function getCompanies(params) {
    
    return function (dispatch) {
        dispatch(getCompaniesRequest())

        return axios.get(`${window.siteUrl}/api/v1/company/`, {
            params: params,
            headers: getHeader()
        })
        .then(function (response) {
            dispatch(getCompaniesReceive(response.data));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("getCompaniesError", err.status, err.data, err.headers);
                dispatch(getCompaniesError(err.data));
            }
        });
    }
}


function updateCompanyDataRequest() {
    return {
        type: types.UPDATE_COMPANY_DATA_REQUEST
    }
}

export function updateCompanyDataReceive(data) {
    return {
        type: types.UPDATE_COMPANY_DATA_SUCCESS,
        payload: data
    }
}

function updateCompanyDataError(messages) {
    return {
        type: types.UPDATE_COMPANY_DATA_FAILURE,
        payload: messages
    }
}

export function updateCompanyData(companyId, params, callback) {
    
    return function (dispatch) {
        dispatch(updateCompanyDataRequest(params))

        return axios.patch(`${window.siteUrl}/api/v1/company/${companyId}/`, 
            params,
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            if(callback && typeof callback === 'function') {
                callback(response.data);
            }

            dispatch(updateCompanyDataReceive(response.data));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("updateCompanyDataError", err.status, err.data, err.headers);
                dispatch(updateCompanyDataError(err.data));
            }
        });
    }
}


function makeInvoiceCompanyRequest() {
    return {
        type: types.PUT_COMPANY_BALANCE_REQUEST
    }
}

function makeInvoiceCompanyReceive(data) {
    return {
        type: types.PUT_COMPANY_BALANCE_SUCCESS,
        payload: data
    }
}

function makeInvoiceCompanyError(messages) {
    return {
        type: types.PUT_COMPANY_BALANCE_FAILURE,
        payload: messages
    }
}

export function makeInvoiceCompany(params, callback, afterError2) {
    
    return function (dispatch) {
        dispatch(makeInvoiceCompanyRequest())

        let {amount, email, token, is_need_original, email_for_original, company, authtoken} = params;

        return axios.get(`${window.siteUrl}/api/v1/make-invoice/${company.id}/`, {
            params: {
                amount,
                authtoken,
                token,
                email,
                is_need_original,
                email_for_original,
            },
            headers: getHeader()
        })
        .then(response => {

            if(callback && typeof callback === 'function'){
                callback();
            }

            dispatch(addCompaniesInvoiceReceive({
                title:'Пополнение баланса (ждет подтверждения администратора)',
                amount: amount.toFixed(2)
            }));
        })
        .catch(error => {
            // if(afterError2 && typeof afterError2 === 'function') {
            //     afterError2();
            // }
            if (error.response) {
                let err = error.response;
                console.error("makeInvoiceCompanyError", err.status, err.data, err.headers);
                dispatch(makeInvoiceCompanyError(err.data));
            }
        });
    }
}

function addCompaniesInvoiceReceive(data) {
    return {
        type: types.ADD_COMPANIES_INVOICE,
        payload: data
    }
}


function getCompanyTransactionsRequest() {
    return {
        type: types.LOAD_COMPANY_TRANSACTIONS_REQUEST
    }
}

function getCompanyTransactionsReceive(data) {
    return {
        type: types.LOAD_COMPANY_TRANSACTIONS_SUCCESS,
        payload: data
    }
}

function getCompanyTransactionsError(messages) {
    return {
        type: types.LOAD_COMPANY_TRANSACTIONS_FAILURE,
        payload: messages
    }
}

export function getCompanyTransactions(company_id) {
    
    return function (dispatch) {
        dispatch(getCompanyTransactionsRequest())

        return axios.get(`${window.siteUrl}/api/v1/money_flow/?company_id=${company_id}`, {
            //params: params,
            headers: getHeader()
        })
        .then(function (response) {
            // console.log("getCompanyTransactionsReceive", response.data)
            dispatch(getCompanyTransactionsReceive(response.data));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("load transaction error-", err.status, err.data, err.headers);
                dispatch(getCompanyTransactionsError(err.data));
            }
        });
    }
}


export function writeOffMoneyCompany(data) {
    return {
        type: types.WRITE_OFF_MONEY_COMPANY,
        data
    }
}



function getCompanyInvoicesReceive(data) {
    return {
        type: types.LOAD_COMPANY_INVOICES_SUCCESS,
        payload: data
    }
}

export function getCompanyInvoices(company_id) {
    
    return function (dispatch) {
        return axios.get(`${window.siteUrl}/api/v1/invoice/?company_id=${company_id}`, {
            //params: params,
            headers: getHeader()
        })
        .then(function (response) {
            // console.log("getCompanyInvoicesReceive", response.data)
            dispatch(getCompanyInvoicesReceive(response.data));
        })
        .catch(function (error) {
            console.error("getCompanyInvoicesReceive error", error);
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/companyActions.js